import { AxiosInstance } from 'axios'

import { paginatedTransform } from 'src/services/skuit/utils'
import { User, PaginatedResponse } from '../../api/models'

import { CustomAxiosConfig } from './types'

export class Users {
  axios: AxiosInstance

  constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<User>> => {
    const response = await this.axios.get('/auth/users', config)
    return paginatedTransform(User)(response.data)
  }
}
